import React from "react";
import ErrorMessage from "../components/ErrorMessage";
import Button from "../components/Button";

interface ErrorViewProps {
  hasHomeButton: boolean;
  message: string;
}

export default function ErrorView({ hasHomeButton, message }: ErrorViewProps) {
  const handleReload = () => {
    window.location.href = "/";
  };

  return (
    <div className="h-100 d-flex flex-column align-items-center justify-content-center">
      <ErrorMessage message={message} />
      {hasHomeButton
      && <Button text="Home" onClick={handleReload} />}
    </div>
  );
}
